import React from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';

import useScreen from 'hooks/useScreen';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';
import Avatar from 'sharedComponents/Avatar';
import Icon from 'sharedComponents/Icon';

import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';
import useStyles from './useStyles';

const TopBar = props => {
  const { onStart, realEstateAgent } = props;
  const { isDesktop } = useScreen();
  const classes = useStyles();
  const { t } = useTranslation();

  const isCompanyLogotypePresent = isPresent(RealEstateAgentPresenter.companyLogoUrl(realEstateAgent));
  const shouldShowLogotype = isCompanyLogotypePresent && isDesktop;

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <div className={classes.leftBar}>
          <Avatar size="m" imageUrl={RealEstateAgentPresenter.profileImageUrl(realEstateAgent)} />
          <div className={classes.badge}>
            <Typography noWrap variant="h3">
              {RealEstateAgentPresenter.fullName(realEstateAgent)}
            </Typography>
            <Typography noWrap variant="subtitle1" color="secondary">
              {RealEstateAgentPresenter.readableCompanyName(realEstateAgent)}
            </Typography>
          </div>
          {shouldShowLogotype && (
            <img
              alt="Company logotype"
              src={RealEstateAgentPresenter.companyLogoUrl(realEstateAgent)}
              className={classes.companyLogo}
            />
          )}
        </div>
        <div className={classes.rightBar}>
          {isDesktop && (
            <Button onClick={onStart} className={classes.button}>
              {t('components.ReferralRealEstateAgent.TopBar.button')}
            </Button>
          )}
          <Icon name="grayLogo" width="100" />
        </div>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  onStart: PropTypes.func.isRequired,
  realEstateAgent: RealEstateAgentPresenter.shape().isRequired,
};

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/TopBar/TopBar.js